<template>
  <div class="operation-box">
    <div class="add" v-if="data">
      <span>{{ title }}({{ data.cabinetCount }})</span>
      <i
        class="iconfont icon-jia"
        @click="showAddInputHandle"
        v-if="isChange != 0"
      ></i>
    </div>
    <ul v-if="data">
      <li v-if="showAddInput" @keyup.enter="addThis">
        <input
          type="text"
          ref="addInput"
          maxlength="10"
          @blur="showAddInput = false"
          v-model="input"
          placeholder="请输入"
          @keyup="input = input.replace(/\s+/g, '')"
        />
        <div class="icon-box">
          <i class="iconfont icon-huiche" @mousedown="addThis"></i>
        </div>
      </li>
      <li
        v-for="(item2, index2) in data.cabinetList"
        :key="index2 + 'b'"
        :class="activeIndex == index2 ? 'active' : ''"
        @click="setItem(index2, item2)"
        @keyup.enter="addThis2(item2.id)"
      >
        <p v-if="showEditInputIndex != index2">{{ item2.cabinetNum }}</p>
        <input
          v-else
          type="text"
          maxlength="10"
          @blur="showEditInputIndex = -1"
          ref="editInput"
          v-model="input"
          @keyup="input = input.replace(/\s+/g, '')"
        />
        <div class="icon-box" v-if="isChange != 0">
          <i
            v-if="showEditInputIndex != index2"
            class="iconfont icon-bianji2"
            @mousedown="showEditInputHandle(index2, item2.cabinetNum)"
          ></i>
          <i
            v-if="showEditInputIndex != index2"
            @mousedown="deleteThis(item2.id)"
            class="iconfont icon-close"
          ></i>
          <i
            v-if="showEditInputIndex == index2"
            class="iconfont icon-huiche"
            @mousedown="addThis2(item2.id)"
          ></i>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import {
  Message
} from 'element-ui';
export default {
  props: ["title", "data", "type", "rootData", "isChange"],
  data() {
    return {
      input: "",
      showAddInput: false,
      showEditInputIndex: -1,
      activeIndex: -1,
    };
  },
  created() {},
  methods: {
    showAddInputHandle() {
      this.showAddInput = true;
      this.$nextTick(() => {
        this.$refs.addInput.focus();
      });
    },
    addThis() {
      if (!this.input) {
        Message("请输入内容后再操作");
        return;
      }
      this.$emit("addItem", this.rootData.id, this.type, this.input);
      this.input = "";
    },
    showEditInputHandle(i, name) {
      this.input = name;
      this.showEditInputIndex = i;
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.editInput[0].focus();
        });
      }, 0);
    },
    addThis2(id) {
      if (!this.input) {
        Message("请输入内容后再操作");
        return;
      }
      this.$emit("upItem", id, this.input);
    },
    setItem(i, e) {
      this.activeIndex = i;
      this.$emit("setItem", e.id);
    },
    deleteThis(id) {
      this.$emit("deleteItem", id);
    },
  },
};
</script>

<style lang="less" scoped>
.operation-box {
  width: 100%;
  padding: 6px;
  box-sizing: border-box;
  height: 100%;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/

    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/

    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/

    border-radius: 10px;

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

    background: #535353;
  }

  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/

    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

    border-radius: 10px;

    background: #ededed;
  }
  .add {
    width: 100%;
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(231, 231, 231, 1);
    i {
      color: rgba(158, 163, 173, 1);
      cursor: pointer;
      font-size: 18px;
    }
  }
  ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    height: auto;
    overflow: auto;
    li {
      width: 300px;
      height: 33px;
      line-height: 33px;
      font-size: 14px;
      color: #152139;
      outline: none;
      position: relative;
      cursor: pointer;
      &.active {
        background: rgba(16, 57, 126, 0.1);
      }
      p {
        width: 100%;
        height: 100%;
        text-indent: 15px;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      input {
        width: 100%;
        height: 100%;
        outline: none;
        border: none;
        font-size: 14px;
        text-indent: 15px;
        background: rgba(16, 57, 126, 0.1);
      }
      .icon-box {
        position: absolute;
        right: 10px;
        top: 0;
        width: 120px;
        height: 33px;
        text-align: right;
        display: none;
        .iconfont {
          margin: 0 10px;
          color: rgba(110, 123, 145, 1);
          cursor: pointer;
        }
      }
      &:hover {
        background: rgba(16, 57, 126, 0.1);
        .icon-box {
          display: block;
        }
      }
    }
  }
}
</style>